import useShowOldPrice from '@/app/hooks/useShowOldPrice';

import { getAffirmPrice } from '../_components/AffirmPromo';
import { useWizardStateContext } from '../_contexts/WizardStateProvider';
import useShowPDPAffirmMessage from './useShowPDPAffirmMessage';

interface FooterPrice {
  affirmPrice: number;
  currencyCode: string;
  discount: number;
  showAffirm: boolean;
  totalPrice: number;
}

const useFooterPrice = (): FooterPrice => {
  const { product } = useWizardStateContext();
  const discountedProductPrice = product?.discountedPrice;
  const showOldPrice = useShowOldPrice();
  const showAffirm = useShowPDPAffirmMessage(
    discountedProductPrice,
    product?.handle,
  );
  const oldPrice = product?.oldPrice?.amount ?? 0;
  let totalPrice = product?.price?.amount ?? 0;

  if (showOldPrice && oldPrice > 0) {
    totalPrice = oldPrice;
  }
  const currencyCode = product?.price?.currencyCode ?? 'USD';
  const originalPrice = discountedProductPrice?.originalPrice?.amount ?? 0;

  const discountedAmount: number =
    discountedProductPrice?.discountedPrice?.amount ?? 0;

  let discount = originalPrice - discountedAmount;
  if (showOldPrice && oldPrice > 0) {
    discount = oldPrice - discountedAmount;
  }

  const affirmPrice = getAffirmPrice(discountedAmount, totalPrice);
  return { affirmPrice, currencyCode, discount, showAffirm, totalPrice };
};

export default useFooterPrice;
